import gql from 'graphql-tag'

export const SUBSCRIBE_ALL_VEHICLES = gql`
    subscription($orgId:uuid!) {
        Vehicles: Vehicles(where:{organizationId:{_eq: $orgId}}, order_by: {updated_at: desc}){
            id
            name
            platNo
            type
            pucExpiryDate
            organizationId
            insuranceDate
            fitnessCertificate
            oilChangeOn
            installmentEmiOn
            lastServiceOn
            created_at
        }
    }`
